import { render, staticRenderFns } from "./crearPedido.vue?vue&type=template&id=5df7bf30"
import script from "./crearPedido.vue?vue&type=script&lang=js"
export * from "./crearPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports